/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import React from 'react';
import { Link } from 'react-router-dom';

function TravelQuoteInfo({ setShowGreeniaAI, travelQuote }) {
    const selectedQuotes = travelQuote?.quote?.filter((quote) => quote.selected === true);
    const optionalQuotes = travelQuote?.quote?.filter((quote) => quote.selected !== true);

    return (
        <div className="w-100 ms-auto mb-3">
            <div className="bg-success border border-success p-3 rounded-3 shadow">
                <h5 className="fs-6 text-white">Nuovo Preventivo Viaggi</h5>
                <hr />
                <div>
                    <div>
                        <div className="row">
                            {selectedQuotes && (
                                <>
                                    <div className="col-12">
                                        <p className="m-0 text-white text-center border-bottom mb-2">
                                            <strong>Incluso</strong>
                                        </p>
                                    </div>

                                    {selectedQuotes.map((quote, index) => (
                                        <div className="col-6 mb-2" key={index}>
                                            <div className="border p-1 rounded-2 h-100">
                                                <p className="m-0 text-white">
                                                    <small>
                                                        <strong>
                                                            Nome:
                                                        </strong>
                                                        {' '}
                                                        {quote?.title}
                                                    </small>
                                                </p>
                                                <p className="m-0 text-white">
                                                    <small>
                                                        <strong>
                                                            Limite:
                                                        </strong>
                                                        {' '}
                                                        {quote?.limitDescription}
                                                    </small>
                                                </p>
                                                <p className="m-0 text-white">
                                                    <small>
                                                        <strong>
                                                            Premio:
                                                        </strong>
                                                        {' '}
                                                        {quote?.coverageRateAmount?.rateGrosAmount}
                                                        {' '}
                                                        €
                                                    </small>
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                            {optionalQuotes && (
                                <>
                                    <div className="col-12">
                                        <hr />
                                    </div>
                                    <div className="col-12">
                                        <p className="m-0 text-white text-center border-bottom mb-2">
                                            <strong>Garanzie</strong>
                                        </p>
                                    </div>
                                    {optionalQuotes.map((quote, index) => (
                                        <div className="col-6 mb-2" key={index}>
                                            <div className="border p-1 rounded-2 h-100">
                                                <p className="m-0 text-white">
                                                    <small>
                                                        <strong>
                                                            Nome:
                                                        </strong>
                                                        {' '}
                                                        {quote?.title}
                                                    </small>
                                                </p>
                                                <p className="m-0 text-white">
                                                    <small>
                                                        <strong>
                                                            Limite:
                                                        </strong>
                                                        {' '}
                                                        {quote?.limitDescription}
                                                    </small>
                                                </p>
                                                <p className="m-0 text-white">
                                                    <small>
                                                        <strong>
                                                            Premio:
                                                        </strong>
                                                        {' '}
                                                        {quote?.coverageRateAmount?.rateGrosAmount}
                                                        {' '}
                                                        €
                                                    </small>
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                        <hr />
                        <div className="row mt-2">
                            <div className="col-12">
                                <Link
                                    onClick={() => setShowGreeniaAI(false)}
                                    className="btn btn-light"
                                    to={`/quote/travel/${travelQuote?.fastQuoteId}`}
                                >
                                    Procedi con il Preventivo
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TravelQuoteInfo;
